import "../styles/Containers.css";
import "../styles/Colors.css";
import "../styles/Loading.css";

const LoadingPage = () => {
  return (
    <div className="paddingTop40">
     <span className="loader"></span>
     <h5 className="purple-1 yekan">در حال دریافت اطلاعات</h5>
      </div>
  );
};
export default LoadingPage;
